import { Navigate } from "react-router-dom";

/** Redirect /list-masters to /list-masters/country */
export default function ListMastersIndex() {
  return <Navigate to="/super-admin/list-masters/country" replace />;
}
